_ = require 'underscore'

isValidDataImage = (url) ->
  _.isString(url) &&
  /^data:image\/(?:png|jpg|jpeg|gif);base64,[A-Za-z0-9+\/=_-]+$/.test(url)

isValidHttp = (url) ->
  _.isString(url) &&
  /^https?:\/\//.test(url)

isValidUrlForImage = (url) ->
  isValidHttp(url) || isValidDataImage(url)

isValidUrlForIframe = (url) ->
  isValidHttp(url)

isValidIframeHeight = (height) ->
  if !height? || !_.isNumber(height)
    return false
  return height >= 1 && height != Infinity

module.exports = {
  isValidIframeHeight,
  isValidUrlForImage,
  isValidUrlForIframe
}



// WEBPACK FOOTER //
// ./app/scripts/lib/util/plugin-validators.coffee